<script>
import numberedPropsToArray from '@/utils/numbered-props-to-array'

export default {
	inheritAttrs: false,
	props: {
		index: Number,
		data: Object,
	},
	data() {
		return {
			padding: null,
		}
	},
	computed: {
		qtyImgMap() {
			return {
				2: { start: 2, end: 3 },
				3: { start: 4, end: 6 },
				4: { start: 7, end: 10 },
				5: { start: 11, end: 15 },
				6: { start: 16, end: 21 },
			}
		},
		start() {
			return this.qtyImgMap[this.qty]?.start
		},
		end() {
			return this.qtyImgMap[this.qty]?.end
		},
		bannerItems() {
			if (this.qty == 1) return numberedPropsToArray(this.data, 1)
			return numberedPropsToArray(this.data, this.end, this.start)
		},
		qty() {
			return this.data.imgQty
		},
	},
	methods: {
		makeVideoProps(data = {}) {
			return {
				videoAttrs: {
					autoplay: this.data.enableAutoplay,
					muted: !this.data.enableSound,
					controls: this.data.enableControls,
					playsinline: 'playsinline',
					style: 'border-radius: 8px',
					class: 'banner-item-video',
					loop: true,
				},
				...this.$b({ ...data }),
			}
		},
	},
	mounted() {
		if (!this.$b.m && this.qty >= 4) {
			const el = this.$refs.bannerContainer.$el
			this.padding = `${el.offsetWidth * 0.01}px`
		}
	},
}
</script>

<template>
	<Container ref="bannerContainer">
		<!-- BANNER 1 -->
		<v-row v-if="qty == 1">
			<v-col cols="12">
				<BannerItem
					v-bind="bannerItems[0]"
					:media-props="$b({ m: { aspectRatio: 380 / 200 } })"
					:video-props="makeVideoProps({ td: { width: 1176, height: 400 } })"
				/>
			</v-col>
		</v-row>

		<!-- BANNER 2 -->
		<v-row v-else-if="qty == 2">
			<v-col cols="12" sm="6" v-for="(i, index) of bannerItems" :key="index">
				<BannerItem
					v-bind="i"
					:media-props="$b({ td: { aspectRatio: 576 / 400 }, m: { aspectRatio: 380 / 200 } })"
					:video-props="makeVideoProps()"
				/>
			</v-col>
		</v-row>

		<!-- BANNER 3 -->
		<v-row v-else-if="qty == 3">
			<v-col cols="12" sm="4" v-for="(i, index) of bannerItems" :key="index">
				<BannerItem
					v-bind="i"
					:media-props="$b({ td: { aspectRatio: 376 / 400 }, m: { aspectRatio: 380 / 200 } })"
					:video-props="makeVideoProps()"
				/>
			</v-col>
		</v-row>

		<!-- BANNER 4 -->
		<v-row v-else-if="qty == 4" :style="$b({ td: { margin: `-${padding}` } })">
			<v-col cols="12" sm="5" :style="$b({ td: { padding } })">
				<BannerItem
					v-bind="bannerItems[0]"
					:video-props="makeVideoProps()"
					:media-props="$b({ td: { aspectRatio: 476 / 400 }, m: { aspectRatio: 380 / 200 } })"
				/>
			</v-col>

			<v-col cols="12" sm="4" :style="$b({ td: { padding } })">
				<v-row :style="$b({ td: { margin: `-${padding}` } })">
					<v-col cols="12" :style="$b({ td: { padding } })">
						<BannerItem
							v-bind="bannerItems[1]"
							:video-props="makeVideoProps()"
							:media-props="$b({ td: { aspectRatio: 376 / 188 }, m: { aspectRatio: 380 / 200 } })"
						/>
					</v-col>
					<v-col cols="12" :style="$b({ td: { padding } })">
						<BannerItem
							v-bind="bannerItems[2]"
							:video-props="makeVideoProps()"
							:media-props="$b({ td: { aspectRatio: 376 / 188 }, m: { aspectRatio: 380 / 200 } })"
						/>
					</v-col>
				</v-row>
			</v-col>

			<v-col cols="12" sm="3" :style="$b({ td: { padding } })">
				<BannerItem
					:media-props="$b({ td: { aspectRatio: 276 / 400 }, m: { aspectRatio: 380 / 200 } })"
					v-bind="bannerItems[3]"
					:video-props="makeVideoProps()"
				/>
			</v-col>
		</v-row>

		<!-- BANNER 5 -->
		<v-row v-else-if="qty == 5" :style="$b({ td: { margin: `-${padding}` } })">
			<v-col cols="12" sm="3" :style="$b({ td: { padding } })">
				<BannerItem
					v-bind="bannerItems[0]"
					:media-props="$b({ td: { aspectRatio: 276 / 400 }, m: { aspectRatio: 380 / 200 } })"
					:video-props="makeVideoProps()"
				/>
			</v-col>

			<v-col cols="6" v-if="$b({ smAndUp: true })" :style="$b({ td: { padding } })">
				<v-row :style="$b({ td: { margin: `-${padding}` } })">
					<v-col cols="12" :style="$b({ td: { padding } })">
						<BannerItem
							:media-props="$b({ td: { aspectRatio: 576 / 188 }, m: { aspectRatio: 380 / 200 } })"
							v-bind="bannerItems[1]"
							:video-props="makeVideoProps()"
						/>
					</v-col>
					<v-col cols="12" sm="6" :style="$b({ td: { padding } })">
						<BannerItem
							:media-props="$b({ td: { aspectRatio: 276 / 188 }, m: { aspectRatio: 380 / 200 } })"
							v-bind="bannerItems[2]"
							:video-props="makeVideoProps()"
						/>
					</v-col>
					<v-col cols="12" sm="6" :style="$b({ td: { padding } })">
						<BannerItem
							:media-props="$b({ td: { aspectRatio: 276 / 188 }, m: { aspectRatio: 380 / 200 } })"
							v-bind="bannerItems[3]"
							:video-props="makeVideoProps()"
						/>
					</v-col>
				</v-row>
			</v-col>

			<v-col v-else>
				<div>
					<BannerItem
						v-bind="bannerItems[1]"
						:video-props="
							makeVideoProps({ td: { width: 576, height: 188 }, m: { aspectRatio: 380 / 200 } })
						"
					/>
				</div>

				<div class="py-6">
					<BannerItem
						v-bind="bannerItems[2]"
						:video-props="
							makeVideoProps({ td: { width: 272, height: 188 }, m: { aspectRatio: 380 / 200 } })
						"
					/>
				</div>

				<div>
					<BannerItem
						v-bind="bannerItems[3]"
						:video-props="
							makeVideoProps({ td: { width: 272, height: 188 }, m: { aspectRatio: 380 / 200 } })
						"
					/>
				</div>
			</v-col>

			<v-col cols="12" sm="3" :style="$b({ td: { padding } })">
				<BannerItem
					:media-props="$b({ td: { aspectRatio: 276 / 400 }, m: { aspectRatio: 380 / 200 } })"
					v-bind="bannerItems[4]"
					:video-props="makeVideoProps()"
				/>
			</v-col>
		</v-row>

		<!-- BANNER 6 -->
		<v-row v-else-if="qty == 6" :style="$b({ td: { margin: `-${padding}` } })">
			<v-col cols="12" md="6" :style="$b({ td: { padding } })">
				<v-row :style="$b({ td: { margin: `-${padding}` } })">
					<v-col cols="12" :style="$b({ td: { padding } })">
						<BannerItem
							v-bind="bannerItems[0]"
							:media-props="$b({ td: { aspectRatio: 576 / 188 }, m: { aspectRatio: 380 / 200 } })"
							:video-props="makeVideoProps()"
						/>
					</v-col>
					<v-col cols="12" sm="6" :style="$b({ td: { padding } })">
						<BannerItem
							v-bind="bannerItems[1]"
							:media-props="$b({ td: { aspectRatio: 276 / 188 }, m: { aspectRatio: 380 / 200 } })"
							:video-props="makeVideoProps()"
						/>
					</v-col>
					<v-col cols="12" sm="6" :style="$b({ td: { padding } })">
						<BannerItem
							v-bind="bannerItems[2]"
							:media-props="$b({ td: { aspectRatio: 276 / 188 }, m: { aspectRatio: 380 / 200 } })"
							:video-props="makeVideoProps()"
						/>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" md="6" :style="$b({ td: { padding } })">
				<v-row :style="$b({ td: { margin: `-${padding}` } })">
					<v-col cols="12" sm="6" :style="$b({ td: { padding } })">
						<BannerItem
							v-bind="bannerItems[3]"
							:media-props="$b({ td: { aspectRatio: 276 / 188 }, m: { aspectRatio: 380 / 200 } })"
							:video-props="makeVideoProps()"
						/>
					</v-col>
					<v-col cols="12" sm="6" :style="$b({ td: { padding } })">
						<BannerItem
							v-bind="bannerItems[4]"
							:media-props="$b({ td: { aspectRatio: 276 / 188 }, m: { aspectRatio: 380 / 200 } })"
							:video-props="makeVideoProps()"
						/>
					</v-col>
					<v-col cols="12" :style="$b({ td: { padding } })">
						<BannerItem
							v-bind="bannerItems[5]"
							:media-props="$b({ td: { aspectRatio: 576 / 188 }, m: { aspectRatio: 380 / 200 } })"
							:video-props="makeVideoProps()"
						/>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</Container>
</template>

<style scoped lang="scss">
::v-deep .banner-item-video {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}
</style>

